import React from 'react';
import { withRouter, Link } from 'react-router-dom';

import makeUrl from '../../../lib/makeUrl';

// import EditButton from "../EditButton";

const NavigateToPlace = ({ history, id, name, altitude, region }) => (
  <li>
    <div className="place-wrap">
      <Link to={makeUrl.placeDetails(name, id, region)}>{name}</Link>
      <p>({altitude && Number(altitude.meters).toLocaleString()} m)</p>
    </div>
  </li>
);

class ItineraryOverview extends React.Component {
  render() {
    const { itinerary, trekId, history, region } = this.props;
    let { trekName } = this.props;
    // eslint-disable-next-line
    trekName = trekName.replace(/\ /g, '-');

    return (
      <div className="white-panel">
        <h2>
          DAY TO DAY ITINERARY
          {/* <EditButton  modalToOpen={"ItineraryEditor"}   /> */}
        </h2>
        <ul className="day-to-day clearfix">
          {Object.values(itinerary).map(day => (
            <li className="clearfix" key={day.day}>
              <div className="day">
                <h5>
                  <Link
                    to={makeUrl.goToDay(trekName, trekId, day.day, region)}
                    className="btn btn-days"
                  >
                    Day {day.day}
                  </Link>
                </h5>
              </div>
              <div className="day-info">
                <ol>
                  {day.places.map((place, i) => (
                    <NavigateToPlace
                      key={`${place.id}`}
                      {...place}
                      history={history}
                      region={region}
                    />
                  ))}
                </ol>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withRouter(ItineraryOverview);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/ItineraryOverview.jsx